import React from 'react'
import './AddRewardsComponent.css'
const AddRewardsComponent = () => {
  return (
    <div className="banner_section" style={{ flex: "1" }}>
      AddRewardsComponent
    </div>
  )
}

export default AddRewardsComponent
